// variables
import { themeOptions } from 'variables';

// libraries
import { Button } from 'antd';
import styled from 'styled-components';

export const StyledTextButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    font-weight: 600 !important;
  }

  &.ant-btn-text {
    border-color: ${themeOptions.palette.mainColor};
    background-color: ${themeOptions.palette.white};
    color: ${themeOptions.palette.mainColor};

    &:hover {
      color: ${themeOptions.palette.white} !important;
      background: ${themeOptions.palette.mainColor} !important;
    }

    &:disabled {
      border-color: #f7d0d4 !important;
      color: #f7d0d4 !important;
      background: ${themeOptions.palette.white} !important;
    }
  }
`;
